export const TypingDots = () => {
  return (
    <div className="flex items-center gap-[4px]">
      <span className="h-[2px] w-[2px] animate-jumping rounded-full bg-foreground [animation-delay:0s]" />
      <span className="h-[2px] w-[2px] animate-jumping rounded-full bg-foreground [animation-delay:0.3s]" />
      <span className="h-[2px] w-[2px] animate-jumping rounded-full bg-foreground [animation-delay:0.6s]" />
    </div>
  );
};
